module.exports = __webpack_public_path__ + "img/icon-line.b43369c8.svg";